import { FieldProps, getIn } from 'formik';
import { isEmpty } from '../../utils/getValidator';
import DateInput, { DateInputProps } from '../atoms/DateInput';
import ErrorMessage from '../atoms/ErrorMessage';

type DateFieldProps = FieldProps & DateInputProps & { label: string; 'data-test-id': string };

const DateField = ({ field, form: { setFieldValue, touched, errors }, meta, label, ...props }: DateFieldProps) => {
  const isTouched = getIn(touched, field.name);
  const error = isTouched && getIn(errors, field.name);
  const hasSuccess =
    isTouched && !error && !isEmpty(typeof field.value === 'string' ? field.value.trim() : field.value);
  const { 'data-test-id': dataTestId } = props;

  return (
    <>
      <DateInput
        placeholder={label}
        hasError={!!error}
        hasSuccess={hasSuccess}
        {...props}
        {...field}
        onChange={value => {
          props.onChange?.(value);
          setFieldValue(field.name, value);
        }}
      />
      <ErrorMessage label={label} error={error} dataTestId={dataTestId} />
    </>
  );
};

export default DateField;
